// extracted by mini-css-extract-plugin
module.exports = {"advert":"adverts_advert__PoF1q"};